import { Modal, Spinner } from "react-bootstrap"
import { useUserUnMergeLineItemsMutation } from "../../../services/ExpenseApi"
import { toast } from "react-toastify"
import { FaEye } from "react-icons/fa6"
import ReactReadMoreReadLess from "react-read-more-read-less";
import { useState } from "react";
import Lightbox from 'react-image-lightbox'


type Props = {
  show: boolean
  onClose: () => void
  selectedDraftData?: any
  refetch?: (expenseId: string) => void
  onSuccess?: () => void
}
interface LightboxData {
  imageURL: string;
}

export default function UnMergeConfirmationModal({
  show,
  onClose,
  refetch,
  selectedDraftData,
  onSuccess
}: Props) {
  const [unMergeLineItem, { isLoading }] = useUserUnMergeLineItemsMutation()
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' });
  const handleConfirmClick = async () => {
    if (!selectedDraftData?.expenseItemId) return

    try {
      await unMergeLineItem({ ccExpenseItemID: selectedDraftData.expenseItemId }).unwrap()

      refetch?.(selectedDraftData?.expenseId)

      onSuccess?.()
      onClose()

    } catch (err) {
      toast.error('Failed to unmerge')

    }
  }

  const isPdfFile = (filePath: string | undefined) => {
    if (!filePath) return false;
    const fileExtension = filePath.toLowerCase().split('.').pop();
    return fileExtension === 'pdf';
  };
  const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
    if (attachmentFile) {
      if (isPdfFile(attachmentFile)) {
        window.open(attachmentFile, '_blank');
      } else {
        setLightboxData({ imageURL: attachmentFile });
        setLightboxOpen(true);
      }
    }
  };
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Unmerge Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Are you sure you want to unmerge this line item?
        </p>

        {selectedDraftData && (
          <div className="table-responsive">
            <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">

              <thead className="">
                <tr>
                  <th style={{ width: "30%" }}>Label</th>
                  <th>Expense Item</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Expense Type</strong></td>
                  <td>{selectedDraftData.expenseType?.title || "--"}</td>
                </tr>
                <tr>
                  <td><strong>Date</strong></td>
                  <td>
                    {selectedDraftData.itemDate
                      ? new Date(selectedDraftData.itemDate).toLocaleDateString()
                      : "--"}
                  </td>
                </tr>
                <tr>
                  <td><strong>Amount</strong></td>
                  <td>
                    {selectedDraftData.currency?.title} {selectedDraftData.amount}
                  </td>
                </tr>
                <tr>
                  <td><strong>Vendor</strong></td>
                  <td>{selectedDraftData.vendor?.name || "--"}</td>
                </tr>
                <tr>
                  <td><strong>Payment Method</strong></td>
                  <td>{selectedDraftData.paymentMethod?.title || "--"}</td>
                </tr>
                <tr>
                  <td><strong>Attachment</strong></td>
                  <td>
                    {selectedDraftData.attachmentFile ? (<>
                      <FaEye className='' onClick={() => openPdfInBrowserOrLightbox(selectedDraftData.attachmentFile)} />
                      {lightboxOpen && (
                        <Lightbox
                          mainSrc={lightboxData.imageURL}
                          onCloseRequest={() => setLightboxOpen(false)}
                          imageCaption="Attachment"
                          enableZoom={true}
                          imagePadding={50}
                        />
                      )}
                    </>
                    ) : 'N/A'}
                  </td>
                </tr>
                <tr>
                  <td><strong>Description</strong></td>
                  <td className="text-wrap">
                    {selectedDraftData?.itemDetail && (
                      <div
                        className="border rounded p-2 overflow-auto"
                        style={{ maxHeight: "120px" }}
                      >
                        <ReactReadMoreReadLess
                          charLimit={100}
                          readMoreText={"Read more"}
                          readLessText={"Read less"}
                          readMoreClassName="text-primary"
                          readLessClassName="text-danger"
                        >
                          {selectedDraftData?.itemDetail}
                        </ReactReadMoreReadLess>
                      </div>
                    )}
                  </td>


                </tr>
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={handleConfirmClick}
          disabled={isLoading}
        >
          {isLoading ? <Spinner animation="border" size="sm" /> : "Unmerge"}
        </button>
      </Modal.Footer>
    </Modal>
  )
}